import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button } from "../../../ui";
import clsx from "clsx";
import { AppContexts } from "../../../providers";
import { groupTags } from "../../../utils/tag-groups";

// Shared tag selector component for selecting/managing tags on rentals
const Tags = ({ value, all, onChange, readOnly = false }) => {
  const settingsContext = useContext(AppContexts.SettingsContext);
  const dropdownRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [filteredTagValues, setFilteredTagValues] = useState([]);

  const handleInputChange = async (tagId, selected) => {
    if (selected) {
      value
        ? await onChange([
            ...value,
            all.find((tagValue) => tagValue.id.toString() === tagId.toString()),
          ])
        : await onChange([
            all.find((tagValue) => tagValue.id.toString() === tagId.toString()),
          ]);
    } else {
      await onChange(
        value.filter((tag) => tag.id.toString() !== tagId.toString()),
      );
    }
  };

  useEffect(() => {
    setFilteredTagValues(all.filter(tag => tag.name.toLowerCase().includes(searchValue.toLowerCase())));
  }, [all, searchValue]);

  const tagSections = useMemo(
    () => groupTags(filteredTagValues, settingsContext.settings?.tag_groups || []),
    [filteredTagValues, settingsContext.settings?.tag_groups],
  );

  return (
    <div className="uk-flex uk-flex-top">
      {!readOnly && (
        <div>
          <Button>
            <img src="/images/tag.svg" />
          </Button>
          <div
            data-uk-dropdown="mode: click"
            className="guest-tags-dropdown"
            ref={dropdownRef}
          >
          <div className="uk-search uk-search-default">
            {searchValue && searchValue !== "" ? (
              <a
                className="uk-form-icon-flip uk-form-icon"
                uk-icon="icon: close"
                onClick={() => setSearchValue("")}
              ></a>
            ) : (
              <span
                className="uk-search-icon-flip"
                uk-search-icon="true"
              />
            )}
            <input
              className="uk-search-input"
              type="search"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <ul className="uk-nav uk-dropdown-nav tags-selector">
            {tagSections.map((section) => (
              <Fragment key={`rental_tag_group_${section.id}`}>
                <li className="tag-group-heading">{section.label}</li>
                {section.tags.map((tagValue) => (
                  <li key={`${section.id}_${tagValue.id}`}>
                    <label
                      className={clsx({
                        disabled:
                          value?.findIndex(
                            (item) =>
                              item.id === tagValue.id &&
                              item.type === "destination",
                          ) >= 0,
                      })}
                    >
                      <input
                        className="uk-checkbox"
                        type="checkbox"
                        checked={
                          value?.findIndex(
                            (tag) => tag.id.toString() === tagValue.id.toString(),
                          ) >= 0
                        }
                        onChange={
                          readOnly
                            ? () => {}
                            : (event) =>
                                handleInputChange(tagValue.id, event.target.checked)
                        }
                        disabled={
                          value?.findIndex(
                            (item) =>
                              item.id === tagValue.id &&
                              item.type === "destination",
                          ) >= 0
                        }
                      />
                      {tagValue.name}
                    </label>
                  </li>
                ))}
              </Fragment>
            ))}
          </ul>
          </div>
        </div>
      )}
      <div className="hms-guest-tags">
        <div className="guest-tags">
          {value &&
            value.map((tag, index) => (
              <div
                className={clsx("uk-inline", {
                  destination: tag.type === "destination",
                })}
                key={index}
              >
                {tag.name}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Tags;
